import { useMemo } from 'react';
import { useImageParams } from './use-image-params.js';
import { useActualImages } from './use-actual-images.js';
import { getImagesByBreakpoint } from '../media/index.js';

function useImages(options) {
  const {
    additionalParameters,
    baseResolutionHeight,
    baseResolutionWidth,
    baseUrl,
    hasWebpSupport,
    images,
    imageType,
    isCdnImage,
    resolutionsByBreakpoint,
    src
  } = options; // Useful if dealing with `src` attribute on Picture

  const imageParams = useImageParams({
    src,
    baseUrl,
    baseResolutionHeight,
    baseResolutionWidth,
    imageType
  }); // Useful if dealing with `images` attribute on Picture

  const actualImages = useActualImages({
    imageParams: isCdnImage ? imageParams : undefined,
    resolutionsByBreakpoint,
    hasWebpSupport,
    images,
    additionalParameters
  });
  const actualImagesByBreakpoint = useMemo(() => getImagesByBreakpoint({
    resolutionsByBreakpoint,
    imageParams,
    additionalParameters,
    hasWebpSupport
  }), [resolutionsByBreakpoint, imageParams, additionalParameters, hasWebpSupport]);
  const finalImageParams = isCdnImage ? undefined : imageParams;
  return {
    actualImages,
    actualImagesByBreakpoint,
    imageParams: finalImageParams
  };
}

export { useImages };
